import { computed, ComputedRef, Ref, ref } from 'vue'
import { DataRow } from '../types/components/data-rendering'
export type SortState = 'asc' | 'desc' | null
export type SortingKeyType = 'array' | 'boolean' | 'date' | 'number' | 'string' | 'time' | null
export interface SortAlgorithReturn {
  setSortingParams: (key: string | null, type: SortingKeyType) => void
  sortingKey: string | null
  sortingKeyType: SortingKeyType
  sortTable: (data: DataRow[]) => DataRow[]
  getAscendingValue: ComputedRef<boolean>
  toggleAscending: () => void
  resetAscending: () => void
}

// TODO?: refactor logic into methods to be called?
export function useSortAlgorithm(): SortAlgorithReturn {
  const sortingKey: Ref<string | null> = ref(null)
  const sortingKeyType: Ref<SortingKeyType> = ref(null)
  const ascending: Ref<boolean> = ref(true)
  const getAscendingValue = computed((): boolean => {
    return ascending.value
  })
  const toggleAscending = (): void => {
    ascending.value = !ascending.value
  }
  const resetAscending = (): void => {
    ascending.value = true
  }
  const setSortingParams = (key: string | null, type: SortingKeyType) => {
    sortingKey.value = key
    sortingKeyType.value = type
  }
  const sortTable = (data: DataRow[]): DataRow[] => {
    let sortedData: DataRow[] = []
    if (sortingKey.value === null) {
      sortedData = data
    }
    if (sortingKeyType.value === 'number' || sortingKeyType.value === 'time') {
      sortedData = data.sort((a, b) =>
        Number(a[sortingKey.value!]) < Number(b[sortingKey.value!]) ? -1 : 1
      )
    }
    if (sortingKeyType.value === 'string') {
      sortedData = data.sort((a, b) => {
        return ('' + a[sortingKey.value!]).localeCompare('' + b[sortingKey.value!], undefined, {
          numeric: true,
        })
      })
    }
    if (sortingKeyType.value === 'boolean') {
      sortedData = data.sort((a, b) => {
        return a[sortingKey.value!] === b[sortingKey.value!] ? 0 : a[sortingKey.value!] ? -1 : 1
      })
    }
    if (sortingKeyType.value === 'date') {
      sortedData = data.sort((a, b) => {
        //TODO?: Swhartzian transformation?
        return new Date(a[sortingKey.value!]).valueOf() - new Date(b[sortingKey.value!]).valueOf()
      })
    }
    if (ascending.value) {
      return sortedData
    } else {
      return sortedData.reverse()
    }

    const out: DataRow[] = []
    for (let index = 0; index < sortedData.length; index++) {
      const row = sortedData[index]
      out.push({ ...row, _index: index })
    }
    return out
  }

  return {
    setSortingParams,
    getAscendingValue,
    sortingKey: sortingKey.value,
    sortingKeyType: sortingKeyType.value,
    sortTable,
    toggleAscending,
    resetAscending,
  }
}
